import React from 'react';
import {Modal} from "react-bootstrap";
import { humanifyDate } from '../../../helpers/UserHelper';

export const LogInfoModal = (props) => {

  const {log, onHide, show} = props;
 
  function hideModel() {    
    onHide();
  }
  
  return(
    <Modal
      {...props}
      onHide={hideModel}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {log.subject}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{__html: log.content}}></div>
      </Modal.Body>
    </Modal>
  )
};
